import { Entity } from "@common/types/entity";
import { isUUID } from "@common/helpers/uuid";

export const REPORTING_SCOPE_QUERY_PARAM = "scope";

const ENTITY_SCOPE_PREFIX = "entity:";
const GROUP_SCOPE_PREFIX = "group:";
const ENTITY_ID_REGEX = /^\d+$/;

export type ReportingRouteScope =
    | {
          kind: "entity";
          id: number;
      }
    | {
          kind: "consolidationGroup";
          id: string;
      };

export const isEligibleReportingEntity = (entity: Entity): boolean =>
    entity.isBusiness && !entity.isMockEntity;

export const buildReportingEntityScope = (entityId: number): string =>
    `${ENTITY_SCOPE_PREFIX}${entityId}`;

export const buildReportingConsolidationScope = (groupId: string): string =>
    `${GROUP_SCOPE_PREFIX}${groupId}`;

export function parseReportingRouteScope(
    value: string | null | undefined,
): ReportingRouteScope | undefined {
    if (value?.startsWith(ENTITY_SCOPE_PREFIX)) {
        const entityId = value.slice(ENTITY_SCOPE_PREFIX.length);
        if (!ENTITY_ID_REGEX.test(entityId)) {
            return undefined;
        }
        const id = Number(entityId);
        return Number.isSafeInteger(id) && id > 0
            ? { kind: "entity", id }
            : undefined;
    }

    if (value?.startsWith(GROUP_SCOPE_PREFIX)) {
        const id = value.slice(GROUP_SCOPE_PREFIX.length);
        return isUUID(id)
            ? { kind: "consolidationGroup", id: id.toLowerCase() }
            : undefined;
    }

    return undefined;
}
